import styled, { css } from "styled-components";

const DropDownButtonStyled = styled.div` 
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        width: 100%;
        background: white;
       
        height: 56px;
        border-radius: 8px;

        button {
            background:#008755 ;
            color: white;
            padding: 10px;
            border-radius: 5px;
            display: flex;
            align-items: center;
            gap: 5px;
            height: 32px;
            font-size: 1.4rem;
            font-weight: 700;

            & > svg {
                pointer-events: none;
            }

            ${props => {
        return (
            props.toggeled &&
            css`
                 {
                    background: #006150;
                }   
     
            `
        );
    }}
        }

        .list {
            position: absolute;
            top: calc(100%);
            right: 16px;
            width: 155px;
            padding: 0;
            margin: 0;
            background: white;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            gap: 0;
            border: 1px solid #CFD0CF;
            overflow: hidden;
        }

        .listItem {
           border-bottom: 1px solid #e0e0e0;
           margin: 0;
           padding: 0;
           display: flex;
           align-items: center;
           color: #757575;
           width: 155px;
           justify-content: start;
           padding: 0px 16px;
           font-size: 1.2rem;
           font-weight: 400;
           height: 36px;
            
        }

        .listItem:hover { 
            background:#E2F3E8;
            cursor: pointer;
        
        }

        .title {
            font-size: 1.6rem;
            font-weight: 700;
         }

         .contentWrapper {
            display: flex;
            align-items: center;
            justify-content: space-between;
            width: 100%;
            padding: 12px 16px;
            height: 100%;
          }

  

`;




export { DropDownButtonStyled };